import SettingsActionTypes from './settings-types'

export const getEnvJson = data => ({
    type: SettingsActionTypes.GET_ENV_JSON,
    payload: data,
})

export const successEnvJson = data => ({
    type: SettingsActionTypes.SUCCESS_ENV_JSON,
    payload: data,
})

export const failureEnvJson = data => ({
    type: SettingsActionTypes.FAILURE_ENV_JSON,
    payload: data,
})

export const fetchOnPageLoad = data => ({
    type: SettingsActionTypes.FETCH_ON_PAGE_LOAD,
    payload: data,
})

export const fetchSupportedCurrencies = data => ({
    type: SettingsActionTypes.FETCH_SUPPORTED_CURRENCIES,
    payload: data,
})

export const successSupportedCurrencies = data => ({
    type: SettingsActionTypes.SUCCESS_SUPPORTED_CURRENCIES,
    payload: data,
})

export const fetchSupportedLanguages = data => ({
    type: SettingsActionTypes.FETCH_SUPPORTED_LANGUAGES,
    payload: data,
})

export const successSupportedLanguages = data => ({
    type: SettingsActionTypes.SUCCESS_SUPPORTED_LANGUAGES,
    payload: data,
})

/***************  Document Requests ****************/
export const fetchDocumentRequests = data => ({
    type: SettingsActionTypes.FETCH_DOCUMENT_REQUEST,
    payload: data,
})

export const successDocumentRequests = data => ({
    type: SettingsActionTypes.SUCCESS_DOCUMENT_REQUEST,
    payload: data,
})

export const finishDocumentRequests = data => ({
    type: SettingsActionTypes.FINISH_DOCUMENT_REQUEST,
    payload: data,
})

export const failureDocumentRequests = data => ({
    type: SettingsActionTypes.FAILURE_DOCUMENT_REQUEST,
    payload: data,
})

/***************  Document Upload ****************/
export const startUploadDocuments = data => ({
    type: SettingsActionTypes.START_UPLOAD_DOCUMENTS,
    payload: data,
})

export const successUploadDocuments = data => ({
    type: SettingsActionTypes.SUCCESS_UPLOAD_DOCUMENTS,
    payload: data,
})

export const finishUploadDocuments = data => ({
    type: SettingsActionTypes.FINISH_UPLOAD_DOCUMENTS,
    payload: data,
})

export const failureUploadDocuments = data => ({
    type: SettingsActionTypes.FAILURE_UPLOAD_DOCUMENTS,
    payload: data,
})

/****************** Change password *******************/
export const startChangePassword = data => ({
    type: SettingsActionTypes.START_CHANGE_PASSWORD,
    payload: data,
})

export const successChangePassword = data => ({
    type: SettingsActionTypes.SUCCESS_CHANGE_PASSWORD,
    payload: data,
})

export const finishChangePassword = data => ({
    type: SettingsActionTypes.FINISH_CHANGE_PASSWORD,
    payload: data,
})

export const failureChangePassword = data => ({
    type: SettingsActionTypes.FAILURE_CHANGE_PASSWORD,
    payload: data,
})

/***************  Support ****************/

export const fetchSupportDepartments = data => ({
    type: SettingsActionTypes.FETCH_SUPPORT_DEPARTMENTS,
    payload: data,
})
export const successSupportDepartments = data => ({
    type: SettingsActionTypes.SUCCESS_SUPPORT_DEPARTMENTS,
    payload: data,
})

export const fetchSupportConversations = data => ({
    type: SettingsActionTypes.FETCH_SUPPORT_CONVERSATIONS,
    payload: data,
})
export const successSupportConversations = data => ({
    type: SettingsActionTypes.SUCCESS_SUPPORT_CONVERSATIONS,
    payload: data,
})
export const failureSupportConversations = data => ({
    type: SettingsActionTypes.FAILURE_SUPPORT_CONVERSATIONS,
    payload: data,
})

export const fetchSupportUnreadConversationsCount = data => ({
    type: SettingsActionTypes.FETCH_SUPPORT_UNREAD_CONVERSATIONS_COUNT,
    payload: data,
})
export const successSupportUnreadConversationsCount = data => ({
    type: SettingsActionTypes.SUCCESS_SUPPORT_UNREAD_CONVERSATIONS_COUNT,
    payload: data,
})
export const failureSupportUnreadConversationsCount = data => ({
    type: SettingsActionTypes.FAILURE_SUPPORT_UNREAD_CONVERSATIONS_COUNT,
    payload: data,
})

export const getSupportConversationsDetails = data => ({
    type: SettingsActionTypes.GET_SUPPORT_CONVERSATION_DETAILS,
    payload: data,
})
export const successSupportConversationsDetails = data => ({
    type: SettingsActionTypes.SUCCESS_SUPPORT_CONVERSATION_DETAILS,
    payload: data,
})
export const failureSupportConversationsDetails = data => ({
    type: SettingsActionTypes.FAILURE_SUPPORT_CONVERSATION_DETAILS,
    payload: data,
})

export const startNewSupportConversations = data => ({
    type: SettingsActionTypes.START_NEW_SUPPORT_CONVERSATIONS,
    payload: data,
})

export const successNewSupportConversations = data => ({
    type: SettingsActionTypes.SUCCESS_NEW_SUPPORT_CONVERSATIONS,
    payload: data,
})

export const finishNewSupportConversations = data => ({
    type: SettingsActionTypes.FINISH_NEW_SUPPORT_CONVERSATIONS,
    payload: data,
})

export const failureNewSupportConversations = data => ({
    type: SettingsActionTypes.FAILURE_NEW_SUPPORT_CONVERSATIONS,
    payload: data,
})

export const startSupportConversationsFile = data => ({
    type: SettingsActionTypes.START_SUPPORT_CONVERSATION_FILE,
    payload: data,
})
export const successSupportConversationsFile = data => ({
    type: SettingsActionTypes.SUCCESS_SUPPORT_CONVERSATION_FILE,
    payload: data,
})
export const finishSupportConversationsFile = data => ({
    type: SettingsActionTypes.FINISH_SUPPORT_CONVERSATION_FILE,
    payload: data,
})
export const failureSupportConversationsFile = data => ({
    type: SettingsActionTypes.FAILURE_SUPPORT_CONVERSATION_FILE,
    payload: data,
})

export const startReplySupportConversations = data => ({
    type: SettingsActionTypes.START_REPLY_SUPPORT_CONVERSATIONS,
    payload: data,
})

export const successReplySupportConversations = data => ({
    type: SettingsActionTypes.SUCCESS_REPLY_SUPPORT_CONVERSATIONS,
    payload: data,
})

export const finishReplySupportConversations = data => ({
    type: SettingsActionTypes.FINISH_REPLY_SUPPORT_CONVERSATIONS,
    payload: data,
})

export const failureReplySupportConversations = data => ({
    type: SettingsActionTypes.FAILURE_REPLY_SUPPORT_CONVERSATIONS,
    payload: data,
})

export const startArchiveSupportConversations = data => ({
    type: SettingsActionTypes.START_ARCHIVE_SUPPORT_CONVERSATIONS,
    payload: data,
})

export const successArchiveSupportConversations = data => ({
    type: SettingsActionTypes.SUCCESS_ARCHIVE_SUPPORT_CONVERSATIONS,
    payload: data,
})

export const finishArchiveSupportConversations = data => ({
    type: SettingsActionTypes.FINISH_ARCHIVE_SUPPORT_CONVERSATIONS,
    payload: data,
})

export const failureArchiveSupportConversations = data => ({
    type: SettingsActionTypes.FAILURE_ARCHIVE_SUPPORT_CONVERSATIONS,
    payload: data,
})

/***************  Fetch System Settings ****************/

export const fetchSystemSettings = data => ({
    type: SettingsActionTypes.FETCH_SYSTEM_SETTINGS,
    payload: data,
})

export const successfetchSystemSettings = data => ({
    type: SettingsActionTypes.SUCCESS_FETCH_SYSTEM_SETTINGS,
    payload: data,
})

/***************  Service Plans ****************/
export const fetchServicePlans = data => ({
    type: SettingsActionTypes.FETCH_SERVICE_PLANS,
    payload: data,
})

export const successFetchServicePlans = data => ({
    type: SettingsActionTypes.SUCCESS_FETCH_SERVICE_PLANS,
    payload: data,
})

export const fetchServiceFeesSchedule = data => ({
    type: SettingsActionTypes.FETCH_SERVICE_FEES_SCHEDULE,
    payload: data,
})

export const successFetchServiceFeesSchedule = data => ({
    type: SettingsActionTypes.SUCCESS_FETCH_SERVICE_FEES_SCHEDULE,
    payload: data,
})

export const fetchServiceFeesScheduleNo = data => ({
    type: SettingsActionTypes.FETCH_SERVICE_FEES_SCHEDULE_NO,
    payload: data,
})
export const successFetchServiceFeesScheduleNo = data => ({
    type: SettingsActionTypes.SUCCESS_FETCH_SERVICE_FEES_SCHEDULE_NO,
    payload: data,
})
export const finishFetchServiceFeesScheduleNo = data => ({
    type: SettingsActionTypes.FINISH_FETCH_SERVICE_FEES_SCHEDULE_NO,
    payload: data,
})

export const startServicePlan = data => ({
    type: SettingsActionTypes.START_SERVICE_PLAN,
    payload: data,
})

export const successServicePlan = data => ({
    type: SettingsActionTypes.SUCCESS_SERVICE_PLAN,
    payload: data,
})

export const finishServicePlan = data => ({
    type: SettingsActionTypes.FINISH_SERVICE_PLAN,
    payload: data,
})

export const errorServicePlan = data => ({
    type: SettingsActionTypes.FAILURE_SERVICE_PLAN,
    payload: data,
})

/****************** Get Document FormData *******************/
export const startGetDocumentFormData = data => ({
    type: SettingsActionTypes.START_GET_DOCUMENT_FORMDATA,
    payload: data,
})

export const successGetDocumentFormData = data => ({
    type: SettingsActionTypes.SUCCESS_GET_DOCUMENT_FORMDATA,
    payload: data,
})

export const finishGetDocumentFormData = data => ({
    type: SettingsActionTypes.FINISH_GET_DOCUMENT_FORMDATA,
    payload: data,
})
/****************** Dynamic Form *******************/
export const startGetDynamicForm = data => ({
    type: SettingsActionTypes.START_GET_DYNAMIC_FORM,
    payload: data,
})

export const successGetDynamicForm = data => ({
    type: SettingsActionTypes.SUCCESS_GET_DYNAMIC_FORM,
    payload: data,
})

export const finishGetDynamicForm = data => ({
    type: SettingsActionTypes.FINISH_GET_DYNAMIC_FORM,
    payload: data,
})

export const failureGetDynamicForm = data => ({
    type: SettingsActionTypes.FAILURE_GET_DYNAMIC_FORM,
    payload: data,
})

export const startUpdateDynamicForm = data => ({
    type: SettingsActionTypes.START_UPDATE_DYNAMIC_FORM,
    payload: data,
})
export const failureUpdateDynamicForm = data => ({
    type: SettingsActionTypes.FAILURE_UPDATE_DYNAMIC_FORM,
    payload: data,
})

/****************** Document Form *******************/
export const startDocumentRequestsForm = data => ({
    type: SettingsActionTypes.START_DOCUMENT_REQUEST_FORM,
    payload: data,
})

export const successDocumentRequestsForm = data => ({
    type: SettingsActionTypes.SUCCESS_DOCUMENT_REQUEST_FORM,
    payload: data,
})

export const finishDocumentRequestsForm = data => ({
    type: SettingsActionTypes.FINISH_DOCUMENT_REQUEST_FORM,
    payload: data,
})

export const failureDocumentRequestsForm = data => ({
    type: SettingsActionTypes.FAILURE_DOCUMENT_REQUEST_FORM,
    payload: data,
})

/****************** Dynamic Document Form *******************/
export const startDynamicFormSubmit = data => ({
    type: SettingsActionTypes.START_DYNAMIC_FORM_SUBMIT,
    payload: data,
})

export const successDynamicFormSubmit = data => ({
    type: SettingsActionTypes.SUCCESS_DYNAMIC_FORM_SUBMIT,
    payload: data,
})

export const finishDynamicFormSubmit = data => ({
    type: SettingsActionTypes.FINISH_DYNAMIC_FORM_SUBMIT,
    payload: data,
})

export const failureDynamicFormSubmit = data => ({
    type: SettingsActionTypes.FAILURE_DYNAMIC_FORM_SUBMIT,
    payload: data,
})

/****************** Company Register Form *******************/
export const startCompanyRegisterForm = data => ({
    type: SettingsActionTypes.START_COMPANY_REGISTER_FORM,
    payload: data,
})

export const successCompanyRegisterForm = data => ({
    type: SettingsActionTypes.SUCCESS_COMPANY_REGISTER_FORM,
    payload: data,
})

export const finishCompanyRegisterForm = data => ({
    type: SettingsActionTypes.FINISH_COMPANY_REGISTER_FORM,
    payload: data,
})

export const failureCompanyRegisterForm = data => ({
    type: SettingsActionTypes.FAILURE_COMPANY_REGISTER_FORM,
    payload: data,
})

/****************** Business Registration *******************/
export const startBusinessRegistration = data => ({
    type: SettingsActionTypes.START_BUSINESS_REGISTRATION,
    payload: data,
})

export const successBusinessRegistration = data => ({
    type: SettingsActionTypes.SUCCESS_BUSINESS_REGISTRATION,
    payload: data,
})

export const finishBusinessRegistration = data => ({
    type: SettingsActionTypes.FINISH_BUSINESS_REGISTRATION,
    payload: data,
})

export const failureBusinessRegistration = data => ({
    type: SettingsActionTypes.FAILURE_BUSINESS_REGISTRATION,
    payload: data,
})

/***************  Get Notifications ****************/

export const startGetNotifications = data => ({
    type: SettingsActionTypes.START_GET_NOTIFICATION,
    payload: data,
})

export const successGetNotifications = data => ({
    type: SettingsActionTypes.SUCCESS_GET_NOTIFICATION,
    payload: data,
})

export const finishGetNotifications = data => ({
    type: SettingsActionTypes.FINISH_GET_NOTIFICATION,
    payload: data,
})

export const failureGetNotifications = data => ({
    type: SettingsActionTypes.FAILURE_GET_NOTIFICATION,
    payload: data,
})

/***************  Get Notifications ****************/

export const startPostNotifications = data => ({
    type: SettingsActionTypes.START_POST_NOTIFICATION,
    payload: data,
})

export const successPostNotifications = data => ({
    type: SettingsActionTypes.SUCCESS_POST_NOTIFICATION,
    payload: data,
})

export const finishPostNotifications = data => ({
    type: SettingsActionTypes.FINISH_POST_NOTIFICATION,
    payload: data,
})

export const failurePostNotifications = data => ({
    type: SettingsActionTypes.FAILURE_POST_NOTIFICATION,
    payload: data,
})

/***************  Submit company form document ****************/

export const startSubmintCompanyFormDocument = data => ({
    type: SettingsActionTypes.START_SUBMIT_COMPANY_FORM_DOCUMENT,
    payload: data,
})

export const successSubmintCompanyFormDocument = data => ({
    type: SettingsActionTypes.SUCCESS_SUBMIT_COMPANY_FORM_DOCUMENT,
    payload: data,
})

export const finishSubmintCompanyFormDocument = data => ({
    type: SettingsActionTypes.FINISH_SUBMIT_COMPANY_FORM_DOCUMENT,
    payload: data,
})

export const failureSubmintCompanyFormDocument = data => ({
    type: SettingsActionTypes.FAILURE_SUBMIT_COMPANY_FORM_DOCUMENT,
    payload: data,
})

/***************  Change main currency ****************/

export const startChangeMainCurrency = data => ({
    type: SettingsActionTypes.START_CHANGE_MAIN_CURRENCY,
    payload: data,
})

export const successChangeMainCurrency = data => ({
    type: SettingsActionTypes.SUCCESS_CHANGE_MAIN_CURRENCY,
    payload: data,
})

export const finishChangeMainCurrency = data => ({
    type: SettingsActionTypes.FINISH_CHANGE_MAIN_CURRENCY,
    payload: data,
})

export const failureChangeMainCurrency = data => ({
    type: SettingsActionTypes.FAILURE_CHANGE_MAIN_CURRENCY,
    payload: data,
})

/***************  Get user Settings****************/

export const getUserSettings = data => ({
    type: SettingsActionTypes.GET_USER_SETTINGS,
    payload: data,
})

export const successGetUserSettings = data => ({
    type: SettingsActionTypes.SUCCESS_GET_USER_SETTINGS,
    payload: data,
})

/***************  Set user Settings****************/

export const startUserSettings = data => ({
    type: SettingsActionTypes.START_USER_SETTINGS,
    payload: data,
})

export const successUserSettings = data => ({
    type: SettingsActionTypes.SUCCESS_USER_SETTINGS,
    payload: data,
})

export const failureUserSettings = data => ({
    type: SettingsActionTypes.FAILURE_USER_SETTINGS,
    payload: data,
})

/***************  Get Company Users ****************/

export const getCompanyUsers = data => ({
    type: SettingsActionTypes.GET_COMPANIES_MEMBERS,
    payload: data,
})

export const successGetCompanyUsers = data => ({
    type: SettingsActionTypes.SUCCESS_GET_COMPANIES_MEMBERS,
    payload: data,
})

/***************  Get Company Users Groups ****************/

export const getCompanyUsersGroups = data => ({
    type: SettingsActionTypes.GET_COMPANIES_MEMBERS_GROUPS,
    payload: data,
})

export const successGetCompanyUsersGroups = data => ({
    type: SettingsActionTypes.SUCCESS_GET_COMPANIES_MEMBERS_GROUPS,
    payload: data,
})

/***************  Add Company Member  ****************/

export const startCompanyMember = data => ({
    type: SettingsActionTypes.START_COMPANIES_MEMBER,
    payload: data,
})

export const successCompanyMember = data => ({
    type: SettingsActionTypes.SUCCESS_COMPANIES_MEMBER,
    payload: data,
})

export const finishCompanyMember = data => ({
    type: SettingsActionTypes.FINISH_COMPANIES_MEMBER,
    payload: data,
})

export const failureCompanyMember = data => ({
    type: SettingsActionTypes.FAILURE_COMPANIES_MEMBER,
    payload: data,
})

/***************  Put Company Member Group ****************/

export const startPutCompanyMemberGroup = data => ({
    type: SettingsActionTypes.START_PUT_COMPANIES_MEMBER_GROUP,
    payload: data,
})

export const successPutCompanyMemberGroup = data => ({
    type: SettingsActionTypes.SUCCESS_PUT_COMPANIES_MEMBER_GROUP,
    payload: data,
})

export const finishPutCompanyMemberGroup = data => ({
    type: SettingsActionTypes.FINISH_PUT_COMPANIES_MEMBER_GROUP,
    payload: data,
})

export const failurePutCompanyMemberGroup = data => ({
    type: SettingsActionTypes.FAILURE_PUT_COMPANIES_MEMBER_GROUP,
    payload: data,
})

/***************  Remove Company Member  ****************/

export const startRemoveCompanyMember = data => ({
    type: SettingsActionTypes.START_REMOVE_COMPANIES_MEMBER_GROUP,
    payload: data,
})

export const successRemoveCompanyMember = data => ({
    type: SettingsActionTypes.SUCCESS_REMOVE_COMPANIES_MEMBER_GROUP,
    payload: data,
})

export const finishRemoveCompanyMember = data => ({
    type: SettingsActionTypes.FINISH_REMOVE_COMPANIES_MEMBER_GROUP,
    payload: data,
})

export const failureRemoveCompanyMember = data => ({
    type: SettingsActionTypes.FAILURE_REMOVE_COMPANIES_MEMBER_GROUP,
    payload: data,
})

/***************  Get File  ****************/
export const startGetFile = data => ({
    type: SettingsActionTypes.START_GET_FILE,
    payload: data,
})
export const successGetFile = data => ({
    type: SettingsActionTypes.SUCCESS_GET_FILE,
    payload: data,
})
export const finishGetFile = data => ({
    type: SettingsActionTypes.FINISH_GET_FILE,
    payload: data,
})
export const failureGetFile = data => ({
    type: SettingsActionTypes.FAILURE_GET_FILE,
    payload: data,
})

/***************  DepositSourceOfFunds  ****************/
export const startUploadSourceOfFunds = data => ({
    type: SettingsActionTypes.START_UPLOAD_DOCUMENT_SOURCE_OF_FUNDS,
    payload: data,
})
export const successUploadSourceOfFunds = data => ({
    type: SettingsActionTypes.SUCCESS_UPLOAD_DOCUMENT_SOURCE_OF_FUNDS,
    payload: data,
})
export const finishUploadSourceOfFunds = data => ({
    type: SettingsActionTypes.FINISH_UPLOAD_DOCUMENT_SOURCE_OF_FUNDS,
    payload: data,
})
export const failureUploadSourceOfFunds = data => ({
    type: SettingsActionTypes.FAILURE_UPLOAD_DOCUMENT_SOURCE_OF_FUNDS,
    payload: data,
})
